import image1 from "../../Images/gmail-clone.svg";
import image2 from "../../Images/gym-website.jpg";
import image3 from "../../Images/meditation.jpg";
import image4 from "../../Images/linkedin.svg";
import image5 from "../../Images/portfolio.jpg";

export const projectInfo = [
  {
    projectTitle: "Gmail clone",
    description:
      "Created using React, Redux, React-router, Firebase authentication, Firebase hosting, Firebase firestore & Material UI.",
    tags: ["react", "react icons", "styled components"],
    source: "https://github.com/NOBERT167/gmail-clone",
    demo: "https://clone-9c640.web.app/",
    image: image1,
    id: 0,
  },
  {
    projectTitle: "Gym website",
    description:
      "Modern, beautifully designed, responsive website. Created using react, react icons, styled components, react router and smooth scroll",
    tags: ["react", "react icons", "styled components", "react scroll"],
    source: "https://github.com/NOBERT167/Gym-website",
    demo: "http://fitness-zone.netlify.app/",
    image: image2,
    id: 1,
  },
  {
    projectTitle: "Meditation App",
    description:
      "Beautifully designed, responsive, very fast, fully functional web application for meditating",
    tags: ["React", "react icons", "react-reveal", "styled components"],
    source: "https://github.com/NOBERT167/meditation-app",
    demo: "http://meditatio-app.netlify.app/",
    image: image3,
    id: 2,
  },
  {
    projectTitle: "LinkedIn Clone",
    description:
      "Created using React, Redux, Firebase authentication, Firebase hosting, Firebase firestore & Material UI.",
    tags: ["React", "Redux", "Material UI", "Firebase"],
    source: "https://github.com/NOBERT167/LinkedIn-clone",
    demo: "https://linkedin-clone-516a4.web.app/",
    image: image4,
    id: 3,
  },
  {
    projectTitle: "Responsive portfolio",
    description:
      "A clean, minimal responsive portfolio. Created using: react, styled components, gsap, react-particles and material UI",
    tags: ["React", "Redux", "Material UI", "styled components"],
    source: "https://github.com/NOBERT167/personal-portfolio",
    demo: "You are looking at it!",
    image: image5,
    id: 4,
  },
];
